/* eslint-disable no-unused-vars */
import { tns } from 'tiny-slider';
import _ from 'lodash.throttle';

function slider() {
  if (document.getElementsByClassName('js-slider').length > 0) {
    const arrowLeft = '<svg width="16" height="31" viewBox="0 0 16 31" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M15 29.1916L1 15.1916L15 1.19165" stroke="#E10613" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    const arrowRight = '<svg width="16" height="31" viewBox="0 0 16 31" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 29.1916L15 15.1916L1 1.19165" stroke="#E10613" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';

    const initSlider = tns({
      mode: 'carousel',
      container: '.js-slider',
      items: 1,
      autoplay: false,
      controls: true,
      controlsText: [arrowLeft, arrowRight],
      nav: true,
      navPosition: 'bottom',
      arrowKeys: true,
    });
  }
}

function gallery() {
  const sliderElements = document.querySelectorAll('.js-gallery');
  if (sliderElements.length) {
    sliderElements.forEach((sliderElement) => {
      tns({
        mode: 'carousel',
        container: sliderElement,
        items: 1,
        autoplay: false,
        controls: true,
        controlsText: ['←', '→'],
        nav: true,
        navPosition: 'bottom',
        arrowKeys: true,
      });
    });
  }
}

function hpNewsSlider() {
  if (document.getElementById('js-news-slider') && window.innerWidth < '1023') {
    const sliderGallery = tns({
      mode: 'carousel',
      container: '#js-news-slider',
      items: 1,
      autoplay: false,
      controls: false,
      nav: true,
      navPosition: 'bottom',
      arrowKeys: true,
      touch: true,
      autoHeight: true,
    });

    window.addEventListener('resize', _.throttle(() => {
      sliderGallery.rebuild();
    }, 250));
  }
}

export function sliders() {
  window.addEventListener('load', slider);
  window.addEventListener('load', gallery);
  window.addEventListener('load', hpNewsSlider);
}
